<template> 
    <div>
        <v-dialog v-model="show" max-width="550" overlay-color="#000" overlay-opacity="0.8" :persistent="loading" :transition="phoneOnly ? 'scroll-x-reverse-transition' : 'dialog-transition'" :fullscreen="phoneOnly" :fluid="phoneOnly" scrollable>
            
            <v-card class="pb-1 px-0 overflow-hidden p-relative has-header" :style="`border-radius: ${phoneOnly ? 0 : 8}px!important`" :class="{'fill-height': phoneOnly}">
                <v-progress-linear v-if="loadingSpinner" :active="loadingSpinner" :indeterminate="loadingSpinner" height="1" absolute top color="white"></v-progress-linear>
                <div :style="statusBarOverlay ? `padding-top: ${statusBarInsetPx+10}px; padding-bottom: ${bottomSafeInsetPx+10}px; ` : ''">

                    <v-toolbar flat fixed class="title-bar surface" height="56" style="border-bottom: 1px solid rgba(0,0,0, 0.08)!important">
                            <v-icon color="transparent" class="pa-2">mdi-arrow-left</v-icon>
                            <v-spacer></v-spacer>
                            <div>
                                <span class="strong-text--text" style="font-size: 1.1rem">{{lecture.name}}</span>
                            </div>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn v-haptic icon depressed color="text" @click.stop.prevent="show = false" small>
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                            </div>
                    </v-toolbar>

                    <div v-if="lecture.image_url" class="pa-5">
                        <v-img :src="lecture.image_url" :max-height="pcOnly ? 300 : 220" class="rounded-lg" />
                    </div>
                    <v-tabs v-model="activeTab" color="primary" light grow class="px-0 mx-0 rounded">
                        <v-tab v-haptic href="#videosTab" style="letter-spacing: 0">
                            <v-icon right>mdi-view-list-outline</v-icon>
                            محتويات المحاضرة
                        </v-tab>
                        <v-tab v-haptic href="#descriptionTab" style="letter-spacing: 0">
                            <v-icon right>mdi-text</v-icon>
                            الوصف
                        </v-tab>
                    </v-tabs>
                </div>
                <v-card-text class="strong-text--text mt-3 px-0" :style="bottomSafeArea ? `padding-bottom: ${bottomSafeInsetPx}px;` : ''">
                    <v-tabs-items v-model="activeTab">
                        <v-tab-item value="videosTab">
                            <lecture-contents-list
                                v-if="items && items.length"
                                :items="items"
                                :attachments="attachments"
                                :lecture="lecture"
                                :opening-exam="openingExam"
                                attendance-chip-placement="title"
                                @play-video="playVideo"
                                @open-exam="openExam"
                            />
                            <div v-else-if="attachments && attachments.length" class="px-4">
                                <lecture-contents-list
                                    :items="[]"
                                    :attachments="attachments"
                                    :lecture="lecture"
                                    :opening-exam="openingExam"
                                    attendance-chip-placement="title"
                                    @play-video="playVideo"
                                    @open-exam="openExam"
                                />
                            </div>
                        </v-tab-item>
                        <v-tab-item value="descriptionTab" class="px-6">
                            <div style="line-height: 2.2; white-space: pre-line;" class="medium-text text--text">{{lecture.description || 'لا يوجد وصف لهذه المحاضرة'}}</div>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="phoneDownloadDialog" max-width="400" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="mb-2">حمل تطبيق الهاتف</v-card-title>
                <v-card-subtitle>لكي تتمكن من مشاهدة المحاضرة؛ يجب عليك تحميل تطبيق الهاتف</v-card-subtitle>
                <v-card-text>
                    <div class="d-flex justify-center align-center">
                        <store-badge type="playstore" width="150px" />
                        <store-badge type="appstore" width="120px" />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <video-dialog v-model="showVideoDialog" :video="showVideo" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import StoreBadge from '@/components/default/store-badge'
import VideoDialog from '@/components/custom/video-dialog'
import LectureContentsList from './lecture-contents-list'

export default {
    props: {
        value: {},
        lecture: {},
        items: {},
        attachments: {},
        pay_type: {}
    },
    components: { StoreBadge, VideoDialog, LectureContentsList },
    data(){
        return {
            activeTab: '',
            show: false,
            loading: false,
            phoneDownloadDialog: false,
            showVideoDialog: false,
            showVideo: null,
            openingExam: false,
        }
    },
    computed: {
        ...GlobalComputed,
        loadingSpinner(){
            return this.openingExam;
        },
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false);
            }
        },
        value(show){
            this.show = show;
        }
    },
    created(){
        this.show = !!this.value;
    },
    methods: {
        playVideo(video){
            this.show = false;
            let wpEnabled = this.wpEnabled;

            if (this.platform === 'web' && !wpEnabled && !this.miniDerasaPlatform){
                if (this.pcOnly){
                    const apiToken = window.localStorage.getItem('tK');
                    const deepLinkProtocol = process.env.VUE_APP_DESKTOP_APP_PROTOCOL;
                    const url = `${deepLinkProtocol}://video?videoId=${video.id}&token=${apiToken}`
                    window.open(url, '_self')
                }else{
                    this.phoneDownloadDialog = true;
                }
            }else if (this.platform === 'android' || this.platform === 'ios' || this.miniDerasaPlatform || wpEnabled){
                window.setTimeout(()=>{
                    this.showVideoDialog = true;
                    this.showVideo = video;
                }, 200);
            }
        },

        openExam(exam){
            const exam_code = exam.navigate_to_alternative && exam.alternative_exam ? exam.alternative_exam.exam_code : exam.exam_code;
            if (!this.openingExam){
                this.openingExam = true;
                window.axios.get(`/exams/details?exam_code=${exam_code}`).then(response=>{
                    this.openingExam = false;
                    this.show = false;
                    const examData = response.data.data;
                    window.setTimeout(()=>{
                        this.$router.push({name: 'exams', params: {examData: examData}, query: {course_id: this.lecture.course_id}})
                    }, 600);

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_FOUND'){
                            this.showMsg('الامتحان غير موجود', 'error');
                        }else if (msg === 'EXAM_NOT_STARTED'){
                            this.showMsg('لم يبدأ الامتحان بعد، انتظر حتى يأتي وقت الامتحان', 'error');
                        }else if (msg === 'EXAM_ENDED'){
                            this.showMsg('انتهى الوقت المسموح فيه بدخول الامتحان', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.openingExam = false;
                })
            }
        },
        backButtonHandler(){
            if (this.showVideoDialog){
                this.showVideoDialog = false;
            }else if (this.show){
                this.show = false;
            }else if (this.$route.name === 'course'){
                this.$router.go(-1);
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler);
        }
    },
    beforeDestroy(){
        if (this.capRunning){
            document.removeEventListener('backbuttonclicked', this.backButtonHandler);
        }
    }
}
</script>
